import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {getDefaultPieFormatting} from '../../charts/pie';

interface IBusinessImpactProps {
    final: any[];
}

const BusinessImpact = ({final}: IBusinessImpactProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const values = ['Yes', 'No'];

        const data = values.map((value) => {
            const y = final.filter((submission: any) => submission.im_t1 === value).length;

            return {
                name: value,
                y,
            };
        });

        const dashboardOptions: any = getDefaultPieFormatting('Business impact measurement', data, 1, {
            subtitle: {
                text: '% of entrepreneurs who introduces measures to their business impact',
                align: 'left',
            },
        });
        
        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default BusinessImpact;
